import { SUSPEND_CATEGORY_LABELS } from './tenant-lifecycle';
export const LIFECYCLE_MESSAGES = {
    'lifecycle.trial_ending': 'Your trial ends in {days} day(s), on {date}.',
    'lifecycle.paid_ending': 'Your subscription ends in {days} day(s), on {date}.',
    'lifecycle.payment_pending': 'We received your payment proof on {date}. Access stays open while we confirm it.',
    'lifecycle.lapsed': 'Subscription ended on {date}. Records can be viewed and printed; new entries are paused.',
    'lifecycle.trial_ended': 'The trial ended on {date}. Records can be viewed and printed; new entries are paused.',
    'lifecycle.suspended': '{reason}: records can be viewed; new entries are paused. Contact support.',
    'lifecycle.blocked': '{reason}: access is limited. Contact support.',
    'lifecycle.frozen': 'Access is limited while we check a security issue — contact support.',
    'lifecycle.closing': 'This account closes on {date}. Download your data before then; records are read-only.',
    'lifecycle.deletion': 'This account is being closed. Records are read-only and can be downloaded until {date}.',
    'lifecycle.archived': 'This account is closed; records are read-only.',
    'lifecycle.action.renew': 'Renew',
    'lifecycle.action.support': 'Contact support',
    'lifecycle.action.export': 'Download your data',
};
const DAY_MS = 24 * 60 * 60 * 1000;
function daysUntil(iso, now) {
    return Math.ceil((Date.parse(iso) - now.getTime()) / DAY_MS);
}
export function lifecycleBanner(lifecycle, options) {
    if (!lifecycle)
        return null;
    const admin = options.isAdmin;
    switch (lifecycle.state) {
        case 'archived':
            return { key: 'lifecycle.archived', tone: 'danger', params: {}, action: admin ? 'export' : null };
        case 'deletion_grace':
            return { key: 'lifecycle.deletion', tone: 'danger', params: { date: lifecycle.deletionDueAt ?? '' }, action: admin ? 'export' : null };
        case 'closing':
            return { key: 'lifecycle.closing', tone: 'danger', params: { date: lifecycle.until ?? '' }, action: admin ? 'export' : null };
        case 'suspended': {
            if (lifecycle.frozen)
                return { key: 'lifecycle.frozen', tone: 'danger', params: {}, action: admin ? 'support' : null };
            const reason = SUSPEND_CATEGORY_LABELS[lifecycle.reasonCategory ?? 'other'];
            return { key: lifecycle.blocked ? 'lifecycle.blocked' : 'lifecycle.suspended', tone: 'danger', params: { reason }, action: admin ? 'support' : null };
        }
        case 'past_due':
            return {
                key: lifecycle.trialEndsAt && !lifecycle.paidUntil ? 'lifecycle.trial_ended' : 'lifecycle.lapsed',
                tone: 'warning',
                params: { date: lifecycle.since ?? '' },
                action: admin ? 'renew' : null,
            };
        case 'trial':
        case 'active': {
            if (lifecycle.pendingRenewalSince) {
                return admin ? { key: 'lifecycle.payment_pending', tone: 'info', params: { date: lifecycle.pendingRenewalSince }, action: null } : null;
            }
            const ends = lifecycle.state === 'trial' ? lifecycle.trialEndsAt : lifecycle.paidUntil;
            if (!ends)
                return null;
            const days = daysUntil(ends, options.now);
            if (days < 0)
                return null;
            const key = lifecycle.state === 'trial' ? 'lifecycle.trial_ending' : 'lifecycle.paid_ending';
            if (days <= 3)
                return { key, tone: 'warning', params: { days, date: ends }, action: admin ? 'renew' : null };
            if (days <= 14 && admin && lifecycle.state === 'trial')
                return { key, tone: 'warning', params: { days, date: ends }, action: 'renew' };
            return null;
        }
    }
}
export function formatLifecycleMessage(key, params, formatDate, messages = LIFECYCLE_MESSAGES) {
    const template = messages[key] ?? LIFECYCLE_MESSAGES[key];
    return template.replace(/\{(\w+)\}/g, (_match, name) => {
        const value = params[name];
        if (value === undefined)
            return '';
        return name === 'date' && typeof value === 'string' && value ? formatDate(value) : String(value);
    });
}
//# sourceMappingURL=lifecycle-banner.js.map